import type { FC } from "react";

import type { PointsRangeItemDefinition, PointsRangeValue } from "./PointsRange.types";
import { ALL_POINTS_RANGES_VALUE } from "./PointsRange.types";
import { PointsRangeItem } from "./PointsRangeItem";

import styles from "./PointsRange.module.scss";

export type PointsRangeProps = {
  items: PointsRangeItemDefinition[];
  allRangesLabel: string;
  value: PointsRangeValue | undefined;
  onChange: (value: PointsRangeValue) => void;
};

export const PointsRange: FC<PointsRangeProps> = ({ items, allRangesLabel, value, onChange }) => {
  const allRangesItem: PointsRangeItemDefinition = {
    value: ALL_POINTS_RANGES_VALUE,
    displayName: allRangesLabel,
  };
  const resolvedItems = [allRangesItem, ...items];
  const selectedValue = value ?? ALL_POINTS_RANGES_VALUE;
  return (
    <div className={styles.pointsRange}>
      {resolvedItems.map((item) => {
        return (
          <PointsRangeItem
            key={item.value}
            {...item}
            checked={item.value === selectedValue}
            onChecked={() => onChange(item.value)}
          />
        );
      })}
    </div>
  );
};
